module.exports = __webpack_public_path__ + "img/menu.843b55d2.svg";